import { Grid } from '@the-platform-group/component-library/Layout'
import { ProfilePicture } from '@the-platform-group/component-library'
import { Typography } from '@the-platform-group/component-library'
import { LinkedIn as LinkedInIcon } from '@the-platform-group/component-library/Icons'
import { IconButton } from '@the-platform-group/component-library'
import RocketReachActions from './components/RocketReachActions'
import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@the-platform-group/component-library/DataGrid'
import CustomDetailPanelToggle from './components/CustomDetailsPanelToggle'
import ContactInformation from './components/ContactInformation'

const rocketReachSearchColumns = [
  {
    field: 'profilePic',
    headerName: '',
    minWidth: 120,
    disableColumnMenu: true,
    flex: null,
    resizable: false,
    align: 'center',
    renderCell: ({ value, row }) => {
      const name = row?.name?.split(' ')
      return (
        <ProfilePicture
          firstName={name?.[0] || ''}
          lastName={name?.[1] || ''}
          profilePictureSrc={value || null}
        />
      )
    },
  },
  {
    field: 'name',
    headerName: 'Contact Name',
    renderCell: ({ value, row }) => (
      <Grid item container xs={9} direction="column">
        <Grid item>
          <Typography>{value}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {row.currentTitle}
          </Typography>
        </Grid>
        {row.linkedinUrl && (
          <Grid item>
            <IconButton href={row.linkedinUrl} target="_blank">
              <LinkedInIcon fontSize="small" color="primary" />
            </IconButton>
          </Grid>
        )}
      </Grid>
    ),
  },
  {
    field: 'currentEmployer',
    headerName: 'Organization Name',
    renderCell: ({ value, row }) => (
      <Grid container spacing={1} direction="column">
        <Grid item>
          <Typography>{value}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {row.location}
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  {
    field: 'currentEmployerDomain',
    headerName: 'Email Syntax',
    renderCell: ({ value }) => <Typography>{value}</Typography>,
  },
  {
    field: 'contactInformation',
    headerName: 'Contact information',
    minWidth: 200,
    renderCell: ({ row }) => <ContactInformation row={row} />,
  },
  {
    ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
    headerName: '',
    minWidth: 40,
    width: 40,
    disableColumnMenu: true,
    flex: null,
    resizable: false,
    renderCell: params => <CustomDetailPanelToggle isExpanded={params.value} />,
  },
  {
    field: 'action',
    headerName: 'Actions',
    align: 'left',
    renderCell: ({ row }) => <RocketReachActions row={row} />,
  },
]

export default rocketReachSearchColumns
